// Copyright (c) Trung Le
// Distributed under the terms of the Modified BSD License.
import { BaseEChartsWidgetModel } from './baseWidgetModel';
import { BaseEChartsWidgetView } from './baseWidgetView';
import { processRawOption } from './tools';
class EChartsRawWidgetModel extends BaseEChartsWidgetModel {
}
EChartsRawWidgetModel.model_name = 'EChartsRawWidgetModel';
EChartsRawWidgetModel.view_name = 'EChartsRawWidgetView';
export { EChartsRawWidgetModel };
class EChartsRawWidgetView extends BaseEChartsWidgetView {
    _createOptionDict() {
        const option = JSON.parse(JSON.stringify(this.model.get('option')));
        processRawOption(option);
        return option;
    }
}
EChartsRawWidgetView.themeManager = BaseEChartsWidgetView.themeManager;
export { EChartsRawWidgetView };
